import { GzDialogWebComponent } from '../../../ui/gzDialog';

export class LicenseChangeCompanionPopUp {
  public static showLicenseChangeCompanionPopUp(
    translateFn,
    shouldButtonsBeVisible: boolean,
    cancelCallback?: null | EventListenerOrEventListenerObject,
    confirmCallback?: null | EventListenerOrEventListenerObject
  ) {
    const dialogBodyHtml = `
      <p>
        ${translateFn(
          'Upgrading to the new product requires agent reconfiguration. New features will be installed, while existing features will retain their settings. You can view the status of this process in the Tasks page.'
        )}
      </p>
    `;

    const dialogFooterHtml = shouldButtonsBeVisible
      ? `
        <gz-button id='confirm' type='outline' color='negative' class='mr-2'>
         ${translateFn('Go to Network')}
        </gz-button>
        <gz-button id='cancel' type='outline' color='secondary'>
          ${translateFn('Later')}
        </gz-button>
      `
      : ``;

    const dialogTitle = translateFn('Reconfigure agent on managed endpoints');

    if (!shouldButtonsBeVisible) {
      cancelCallback = null;
      confirmCallback = null;
    }

    GzDialogWebComponent.computeCustomDialog(
      dialogBodyHtml,
      dialogFooterHtml,
      dialogTitle,
      cancelCallback,
      confirmCallback
    );
  }
}
